import React, { useEffect, useState } from "react";
import axios from "axios";
import { validateTrainerForm } from "../../Validate";
import { MdCardMembership } from "react-icons/md";
import Swal from "sweetalert2";

const EditTrainerModal = ({ show, onClose, onSubmit, initialData }) => {
  const [formData, setFormData] = React.useState({
    trainer_from_zone_18: initialData.trainer_from_zone_18 || "",
    membershipId: initialData.jci_membership_id || "",
    member_id: initialData.member_id || "",
    zone_trainer_id: initialData.zone_trainer_id || "",
    name: initialData.name || "",
    lom_name: initialData.lom_name || "",
    lomId: initialData.lom_id || "",
    highest_portfolio: initialData.highest_portfolio || "",
    portfolio_year: initialData.portfolio_year || "",
    dob: initialData.dob || "",
    education_qualification: initialData.education_qualification || "",
    whatsapp_number: initialData.whatsapp_number || "",
    contact_number: initialData.contact_number || "",
    // instagram_id: initialData.instagram_id || "",
    facebook: initialData.facebook || "",
    instagram: initialData.instagram || "",
    youtube: initialData.youtube || "",
    linkedIn: initialData.linkedin || "",
    address: initialData.address || "",
    district_name: initialData.district_name || "",
    district_id: initialData.district_id || "",
    graduated: initialData.graduated || false,
    graduated_year: initialData.graduated_year || "",
    no_of_lo_level_trainings: initialData.no_of_lo_level_trainings || "",
    no_of_corporate_trainings: initialData.no_of_corporate_trainings || "",
    trainings: initialData.trainings || {},
    highest_position_training: initialData.highest_position_training || "",
    images: initialData.images,
    trainingsOffered: {
      jciOrientation: initialData.trainings?.jciOrientation || false,
      effectivePublicSpeaking:
        initialData.trainings?.effectivePublicSpeaking || false,
      empoweringYouth: initialData.trainings?.empoweringYouth || false,
      futureLeadership: initialData.trainings?.futureLeadership || false,
      leaderTrainingSeries:
        initialData.trainings?.leaderTrainingSeries || false,
      loIdTraining: initialData.trainings?.loIdTraining || false,
      businessTrainings: initialData.trainings?.businessTrainings || false,
      industrialTrainings: initialData.trainings?.industrialTrainings || false,
      institutionalTrainings:
        initialData.trainings?.institutionalTrainings || false,
      others: initialData.trainings?.others || false,
    },
    selectedTrainingIds: initialData.selectedTrainingIds || "", // New field for storing selected IDs
  });

  const [profileImage, setProfileImage] = useState(null);
  const [loms, setLoms] = useState([]);
  const [errors, setErrors] = useState({});
  const [fileError, setFileError] = useState(""); // State for error message

  const [districtOptions, setDistrictOptions] = useState([]);

  useEffect(() => {
    if (formData.trainer_from_zone_18) {
      fetchDistrictOptions();
    }
  }, [formData.trainer_from_zone_18]);

  const fetchDistrictOptions = async () => {
    try {
      const zoneValue = formData.trainer_from_zone_18;
      const response = await axios.get(
        `/zone_district/read_zone_18?zone_18=${zoneValue}`
      );
      const districts = response.data.map((district) => ({
        district_id: district.district_id,
        district_name: district.district_name,
      }));
      setDistrictOptions(districts);
    } catch (error) {
      console.error("Error fetching districts:", error);
      setDistrictOptions([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // alert(name)
    // alert(value)
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/svg+xml",
      ];
      const maxFileSize = 1 * 1024 * 1024; // 1 MB in bytes

      if (!allowedTypes.includes(file.type)) {
        setFileError("Only JPEG, JPG, PNG, and SVG formats are allowed.");
        setFormData((prevData) => ({ ...prevData, images: null })); // Clear invalid file
        return;
      }

      if (file.size > maxFileSize) {
        setFileError("File size must be less than 1 MB.");
        setFormData((prevData) => ({ ...prevData, images: null })); // Clear invalid file
        return;
      }

      // If validation passes, clear error and update form data
      setFileError(""); // Clear error
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
        setFormData((prevData) => ({
          ...prevData,
          images: file, // Store the file object
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setFileError("Please select a file.");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Uncomment this to enable validation
    const validationErrors = validateTrainerForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const data = new FormData();

    // Append all the form fields to FormData, skipping empty or invalid fields
    Object.keys(formData).forEach((key) => {
      const value = formData[key];
      if (
        key !== "images" &&
        value !== null &&
        value !== undefined &&
        value !== ""
      ) {
        if (typeof value === "string" && value.trim() !== "") {
          data.append(key, value.trim()); // Trim strings
        } else if (typeof value !== "string") {
          data.append(key, value); // Append non-string values directly
        }
      }
    });

    // Append the image file if available
    if (formData.images) {
      data.append("images", formData.images);
    }
    axios
      .put("/member/update_member_zone_trainer", data)
      .then((response) => {
        // console.log('Record updated successfully:', response.data);
        Swal.fire(
          "Successfully!",
          "Record updated successfully",
          "success"
        ).then(() => {
          onClose(); // Close the modal or perform other actions
          window.location.reload(); // Reload the page after successful update
        });
      })
      .catch((error) => {
        console.error("Error updating record:", error);
        alert("Failed to update the record. Please try again.");
      });
  };

  // Parse selectedTrainingIds to pre-select checkboxes
  useEffect(() => {
    if (initialData.selectedTrainingIds) {
      const selectedIdsArray = initialData.selectedTrainingIds
        .split(",")
        .map(Number);

      setFormData((prevData) => {
        const updatedTrainingsOffered = Object.keys(
          prevData.trainingsOffered
        ).reduce((acc, key, index) => {
          acc[key] = selectedIdsArray.includes(index + 1); // Set true if ID is in selectedTrainingIds
          return acc;
        }, {});

        return {
          ...prevData,
          trainingsOffered: updatedTrainingsOffered,
        };
      });
    }
  }, [initialData.selectedTrainingIds]);

  const handleChange1 = (e) => {
    const { name, checked } = e.target;

    setFormData((prevData) => {
      const updatedTrainings = {
        ...prevData.trainingsOffered,
        [name]: checked,
      };

      // Mapping checkbox names to their respective IDs
      const trainingIdMap = {
        jciOrientation: 1,
        effectivePublicSpeaking: 2,
        empoweringYouth: 3,
        futureLeadership: 4,
        leaderTrainingSeries: 5,
        loIdTraining: 6,
        businessTrainings: 7,
        industrialTrainings: 8,
        institutionalTrainings: 9,
        others: 10,
      };

      // Generate a comma-separated string of selected IDs based on the updated checkboxes
      const selectedIds = Object.keys(updatedTrainings)
        .filter((key) => updatedTrainings[key]) // Filter selected checkboxes
        .map((key) => trainingIdMap[key]) // Map to the correct ID using the trainingIdMap
        .join(","); // Join the IDs into a comma-separated string

      return {
        ...prevData,
        trainingsOffered: updatedTrainings,
        selectedTrainingIds: selectedIds, // Store the selected IDs
      };
    });
  };

  useEffect(() => {
    axios
      .get("/lom/read")
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : [];
        setLoms(data);
      })
      .catch((error) => console.error("Error fetching LOMs:", error));
  }, []);

  useEffect(() => {
    if (formData.trainer_from_zone_18) {
      fetchDistrictOptions();
    }
  }, [formData.trainer_from_zone_18]);

  useEffect(() => {
    const url = sessionStorage.getItem("url");
    setProfileImage(
      `${url}/member/zone_trainers_images/${formData.images}` ||
        "/default_avatar.png"
    );
  }, []);

  return (
    show && (
      <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
        <div className="bg-white p-6 max-w-2xl w-full rounded shadow-lg">
          <h2 className="text-lg font-bold mb-4">Edit Trainer Form</h2>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-[80vh] overflow-y-auto">
              <div className="sm:col-span-2 item_center">
                <div className="flex flex-col items-center mb-4">
                  {/* Display the selected image */}
                  <img
                    src={profileImage} // Display the selected image
                    alt="Profile"
                    className="w-24 h-24 rounded-full object-cover border border-gray-300"
                  />

                  {/* Change Profile Picture label */}
                  <label className="mt-2 text-sm text-blue-500 hover:underline cursor-pointer">
                    Change Profile Picture
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      className="hidden"
                    />
                  </label>
                </div>

                {/* Display error message if any */}
                {fileError && (
                  <p className="text-red-500 text-sm mt-1">{fileError}</p>
                )}
              </div>

              {/* Trainer from Zone XVIII (18) */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Trainer from Zone XVIII (18)
                  <span className="text-red-600"> *</span>
                </label>
                <select
                  name="trainer_from_zone_18"
                  value={formData.trainer_from_zone_18}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  required
                >
                  <option value="">Select Yes or No</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {/* <h1>{formData.trainer_from_zone_18}</h1> */}
                {errors.trainer_from_zone_18 && (
                  <p className="text-red-600 text-sm mt-1">
                    {errors.trainer_from_zone_18}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Jci Membership Id<span className="text-red-600"> *</span>
                </label>
                <input
                  type="text"
                  name="membershipId"
                  value={formData.membershipId}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.membershipId}</h1> */}
                {errors.membershipId && (
                  <p className="text-red-600 text-sm mt-1">
                    {errors.membershipId}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Name with Title <span className="text-red-600"> *</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.name}</h1> */}
                {errors.name && (
                  <p className="text-red-600 text-sm mt-1">{errors.name}</p>
                )}
              </div>

              {/* Local Organization Name */}
              <div className="mb-4">
                <label className="block mb-2">
                  LO
                  <span className="text-red-600"> *</span>
                </label>
                <select
                  id="lomDropdown"
                  className="border rounded p-2 w-full"
                  value={formData.lomId}
                  onChange={(event) =>
                    setFormData({ ...formData, lomId: event.target.value })
                  }
                  required
                >
                  <option value="">-- Select an Option --</option>
                  {loms.map((lom) => (
                    <option key={lom.lom_id} value={lom.lom_id}>
                      {lom.lom_name}
                    </option>
                  ))}
                </select>
                {/* <h1>{formData.lomId}</h1> */}
              </div>

              {/* Highest Portfolio */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Highest Portfolio in JCI{" "}
                  <span className="text-red-600"> *</span>
                </label>
                <input
                  type="text"
                  name="highest_portfolio"
                  value={formData.highest_portfolio}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.highest_portfolio}</h1> */}
                {errors.highest_portfolio && (
                  <p className="text-red-600 text-sm mt-1">
                    {errors.highest_portfolio}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Portfolio Year <span className="text-red-600"> *</span>
                </label>
                <select
                  name="portfolio_year"
                  value={formData.portfolio_year}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  required
                >
                  <option value="" disabled>
                    Select Year
                  </option>
                  {Array.from({ length: 50 }, (_, index) => {
                    const year = new Date().getFullYear() - index; // Generate past 50 years
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </select>
                {/* <h1>{formData.portfolio_year}</h1> */}
              </div>

              {/* Date of Birth */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Date of Birth <span className="text-red-600"> *</span>
                </label>
                <input
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.dob}</h1> */}
                {errors.dob && (
                  <p className="text-red-600 text-sm mt-1">{errors.dob}</p>
                )}
              </div>

              {/* Education Qualification */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Education Qualification
                </label>
                <input
                  type="text"
                  name="education_qualification"
                  value={formData.education_qualification}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.education_qualification}</h1> */}
              </div>

              {/* Whatsapp and Contact Numbers */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Whatsapp Number <span className="text-red-600"> *</span>
                </label>
                <input
                  type="text"
                  name="whatsapp_number"
                  value={formData.whatsapp_number}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  required
                />
                {errors.whatsapp_number && (
                  <p className="text-red-600 text-sm mt-1">
                    {errors.whatsapp_number}
                  </p>
                )}
                {/* <h1>{formData.whatsapp_number}</h1> */}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Contact Number <span className="text-red-600"> *</span>
                </label>
                <input
                  type="text"
                  name="contact_number"
                  value={formData.contact_number}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                />
                {errors.contact_number && (
                  <p className="text-red-600 text-sm mt-1">
                    {errors.contact_number}
                  </p>
                )}
                {/* <h1>{formData.contact_number}</h1> */}
              </div>

              {/* Instagram ID */}
              {/* <div>
                <label className="block text-sm font-medium mb-1">
                  Instagram ID Name
                </label>
                <input
                  type="text"
                  name="instagram_id"
                  value={formData.instagram_id}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
             
              </div> */}
              <div>
                <label className="block text-sm font-medium mb-1">Facebook</label>
                <input
                  type="url"
                  name="facebook"
                  value={formData.facebook}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {errors.facebook && <p className="text-red-500 text-sm">{errors.facebook}</p>}
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Instagram</label>
                <input
                  type="url"
                  name="instagram"
                  value={formData.instagram}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {errors.instagram && <p className="text-red-500 text-sm">{errors.instagram}</p>}
              </div>
              <div>
              <label className="block text-sm font-medium mb-1">YouTube</label>
              <input
                type="url"
                name="youtube"
                value={formData.youtube}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.youtube && <p className="text-red-500 text-sm">{errors.youtube}</p>}
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">LinkedIn</label>
              <input
                type="url"
                name="linkedIn"
                value={formData.linkedIn}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.linkedIn && <p className="text-red-500 text-sm">{errors.linkedIn}</p>}
            </div>

              {/* Communication Address */}
              <div className="sm:col-span-2">
                <label className="block text-sm font-medium mb-1">
                  Communication Address
                </label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.address}</h1> */}
              </div>

              {/* District Dropdown */}
              {formData.trainer_from_zone_18 === "Yes" && (
                <div className="mb-4">
                  <label className="block mb-2">
                    District<span className="text-red-600"> *</span>
                  </label>
                  <select
                    name="district_id"
                    value={formData.district_id || ""} // Bind the value to formData.district_id
                    onChange={(event) => {
                      const selectedDistrict = districtOptions.find(
                        (district) =>
                          district.district_id === parseInt(event.target.value) // Match by district_id
                      );
                      handleChange({
                        target: {
                          name: "district_id",
                          value: event.target.value, // Update district_id in formData
                        },
                      });
                      // handleChange({
                      //   target: {
                      //     name: "district_name",
                      //     value: selectedDistrict ? selectedDistrict.district_name : "", // Update district name in formData
                      //   },
                      // });
                    }}
                    required
                    className="border rounded p-2 w-full"
                  >
                    <option value="" disabled>
                      Select a district
                    </option>
                    {districtOptions.map((district) => (
                      <option
                        key={district.district_id}
                        value={district.district_id}
                      >
                        {district.district_name}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {formData.trainer_from_zone_18 === "No" && (
                <div className="mb-4">
                  <label className="block mb-2">
                    District<span className="text-red-600"> *</span>
                  </label>
                  <input
                    list="district-options"
                    name="district_id"
                    value={
                      formData.district_id
                        ? districtOptions.find(
                            (district) =>
                              district.district_id ===
                              parseInt(formData.district_id)
                          )?.district_name || formData.district_id
                        : ""
                    }
                    onChange={(event) => {
                      const districtName = event.target.value;
                      const selectedDistrict = districtOptions.find(
                        (district) => district.district_name === districtName
                      );

                      if (selectedDistrict) {
                        handleChange({
                          target: {
                            name: "district_id",
                            value: selectedDistrict.district_id,
                          },
                        });
                      } else {
                        handleChange({
                          target: {
                            name: "district_id",
                            value: districtName,
                          },
                        });
                      }
                    }}
                    onBlur={(event) => {
                      const districtName = event.target.value;
                      const existingDistrict = districtOptions.find(
                        (district) => district.district_name === districtName
                      );

                      if (!existingDistrict && districtName.trim()) {
                        const newDistrictId = districtOptions.length + 1; // Example of unique ID generation
                        const newDistrict = {
                          district_id: newDistrictId,
                          district_name: districtName,
                        };

                        districtOptions.push(newDistrict); // Add to the list dynamically
                        handleChange({
                          target: {
                            name: "district_id",
                            value: newDistrictId,
                          },
                        });
                      }
                    }}
                    required
                    className="border rounded p-2 w-full"
                    placeholder="Select or type a district"
                  />
                  <datalist id="district-options">
                    {districtOptions.map((district) => (
                      <option
                        key={district.district_id}
                        value={district.district_name}
                      />
                    ))}
                  </datalist>
                </div>
              )}

              {/* Graduation Status */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Graduated
                </label>
                <select
                  name="graduated"
                  value={formData.graduated}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="">Select Yes or No</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {/* <h1>{formData.graduated}</h1> */}
              </div>

              {/* Graduated Year */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Graduated Year
                </label>
                <select
                  name="graduated_year"
                  value={formData.graduated_year}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="" disabled>
                    Select Year
                  </option>
                  {Array.from({ length: 50 }, (_, index) => {
                    const year = new Date().getFullYear() - index; // Generate past 50 years
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </select>
                {/* <h1>{formData.graduated_year}</h1> */}
              </div>

              {/* Trainings Numbers */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Number of LO Level Trainings as Faculty
                </label>
                <input
                  type="text"
                  name="no_of_lo_level_trainings"
                  value={formData.no_of_lo_level_trainings}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.no_of_lo_level_trainings}</h1> */}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">
                  Number of Corporate Trainings Conducted
                </label>
                <input
                  type="text"
                  name="no_of_corporate_trainings"
                  value={formData.no_of_corporate_trainings}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.no_of_corporate_trainings}</h1> */}
              </div>

              <div className="sm:col-span-2">
                <label className="block text-sm font-medium mb-1">
                  Trainings I Would Love to Offer
                </label>
                <div className="grid grid-cols-2 gap-4">
                  {Object.keys(formData.trainingsOffered).map(
                    (trainingKey, index) => (
                      <div key={trainingKey}>
                        <input
                          type="checkbox"
                          id={`training-${index + 1}`} // Unique ID for each checkbox
                          name={trainingKey}
                          checked={formData.trainingsOffered[trainingKey]}
                          onChange={(e) => handleChange1(e, index)}
                          className="h-5 w-5"
                        />
                        <label
                          htmlFor={`training-${index + 1}`}
                          className="ml-2"
                        >
                          {trainingKey.replace(/([A-Z])/g, " $1")}
                        </label>
                      </div>
                    )
                  )}
                  {/* <p>Selected Training IDs: {formData.selectedTrainingIds}</p> */}
                </div>
              </div>

              {/* Area of Training Specialization */}
              <div className="sm:col-span-2">
                <label className="block text-sm font-medium mb-1">
                  Area of Training Specialization{" "}
                  <span className="text-red-600"> *</span>
                </label>
                <input
                  type="text"
                  name="highest_position_training"
                  value={formData.highest_position_training}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.highest_position_training}</h1> */}
                {errors.highest_position_training && (
                  <p className="text-red-600 text-sm mt-1">
                    {errors.highest_position_training}
                  </p>
                )}
              </div>
            </div>

            {/* Buttons */}
            <div className="mt-4 flex justify-end space-x-2">
              <button
                type="button"
                onClick={onClose}
                className="bg-gray-500 text-white px-4 py-2 rounded"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  );
};

export default EditTrainerModal;
